import React from 'react'

// Local inline glyph, not from @fs/zion-icon (its ControlGrid is nine
// outlined squares in a frame). Four rounded squares, the conventional
// "all apps" mark — it sits next to NineDotIcon in the drawer, where the
// waffle means "the level above inside this experience" and this means
// "out to every experience", so the two must not look alike.
export default function GridSquaresIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
      {[3, 13].map((y) => [3, 13].map((x) => <rect key={`${x}-${y}`} x={x} y={y} width="8" height="8" rx="2" />))}
    </svg>
  )
}
